<template>
    <div class="">
        <div class="row" role="group">

            <!-- regular radios -->
            <div v-if="showAs === 'radio'" class="" :class="fieldInnerClass ?? 'col-md-12'">
                <div class="form-check" :class="{ 'mt-3': index !== 0 }" v-for="(choice, index) in choices" :key="choice.value">
                    <label class="form-check-label" :for="name + index">
                        <input
                            class="form-check-input"
                            type="radio"
                            :value="choice.value"
                            @change.prevent="$emit('inputFromRadio', $event.target.value);"
                            :name="name"
                            :id="name + index"
                        />
                        <span v-html="getTranslatedText(choice.text, 'fields.options')"></span>
                    </label>
                </div>
            </div>

            <!-- as buttons -->
            <div v-else class="btn-group btn-group-lg" :class="fieldInnerClass ?? 'col-md-12'" v-for="(choice, index) in choices" :key="choice.value">
                <label
                class="btn "
                :class="[ {'mt-3': index !== 0}, {'active': choice.value === value || (isMobileDevice && isHovered) }, choice.btnClass ?? 'btn-outline-'+(inputColor.radio ?? 'primary'), {'mobile': isMobileDevice} ]"
                @mouseenter="isHovered = true"
                @mouseleave="isHovered = false"
                >
                    <input
                        type="radio"
                        :value="choice.value"
                        @input.prevent="$emit('inputFromRadioButton', $event.target.value);"
                        :checked="choice.value === value"
                        :name="name"
                        @click.prevent="$emit('inputFromRadioButton', $event.target.value);"
                        style="display:none;"
                    />
                    <span v-html="getTranslatedText(choice.text, 'fields.options')"></span>
                </label>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, inject } from 'vue';
import { isTouchDevice } from '@/utils/device.js';

defineProps({
    choices: { type: Array, required: true },
    value: { type: [String, Number], default: undefined },
    name: { type: String, required: true },
    label: { type: String, default: '' },
    fieldInnerClass: { type: String, default: undefined },
    inputColor: { type: Object, default: () => ({}) },
    showAs: { type: String, default: undefined },
});
defineEmits(["update:model-value","input","input-from-radio","input-from-radio-button","inputFromRadio","inputFromRadioButton","goToNextStep","blur"]);

const isHovered = ref(false);
const isMobileDevice = isTouchDevice();
const { getTranslatedText } = inject('app');
</script>

<style scoped>
    .btn.mobile, .btn.mobile:hover {
        --bs-btn-color: #0d6efd;
        --bs-btn-bg: transparent;
        --bs-btn-border-color: #0d6efd;

        color: var(--bs-btn-color);
        background-color: var(--bs-btn-bg);
        border-color: var(--bs-btn-border-color);
    }
</style>
